import { c as _c } from "react/compiler-runtime";
import { Container } from "@opensea/ui-kit";
export function PageFooterContainer(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="hidden h-page-footer lg:block"><footer className="fixed right-scroll-bar-size bottom-0 left-side-nav z-[calc(var(--z-sidebar)-1)] h-page-footer border-border-1 border-t bg-bg-app lg:right-[calc(theme(spacing.scroll-bar-size))]"><Container className="flex h-full items-center">{children}</Container></footer></div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}